module.exports = __webpack_public_path__ + "img/job-medium.b62539ab.svg";